import { Link } from 'react-router-dom';
import {
    HealthAndSafetyOutlined,
    HealingOutlined,
    SelfImprovementOutlined,
    DirectionsRunOutlined,
    ArrowForwardIos
} from '@mui/icons-material';
import DocPageLayout from './DocPageLayout.js';
import './DocPage.css';

const heroImage = '/img/acute-pain.jpg';

const Symptoms = () => (
    <DocPageLayout
        currentRoute="/symptoms"
        pageLabel="SYMPTOM GUIDE"
        pageTitle="症状から選ぶ"
        heroImage={heroImage}
        heroImageAlt="症状に悩む方"
        heroHighlight="気になる症状を選んで、詳しい対策をご覧ください"
        heroDescription="腰痛と肩こり・五十肩に関する詳しい解説と当院の施術方針を個別にご案内します。"
    >
        <article className="doc-section doc-section--selection">
            <h3 className="doc-section__title">症状別ページをお選びください</h3>
            <div className="doc-section__body">
                <div className="doc-selection">

                    <Link className="doc-selection__card" to="/symptoms/neck-pain">
                        <span className="doc-selection__icon-wrapper">
                            <SelfImprovementOutlined className="doc-selection__icon" />
                        </span>
                        <div className="doc-selection__content">
                            <span className="doc-selection__label">首の痛み</span>
                            <p className="doc-selection__description">
                                首や寝違えの原因、施術の特徴とセルフケアの注意点をご紹介します。
                            </p>
                        </div>
                        <span className="doc-selection__cta">
                            <ArrowForwardIos className="doc-selection__cta-icon" />
                        </span>
                    </Link>
                    <Link className="doc-selection__card" to="/symptoms/shoulder-pain">
                        <span className="doc-selection__icon-wrapper">
                            <HealingOutlined className="doc-selection__icon" />
                        </span>
                        <div className="doc-selection__content">
                            <span className="doc-selection__label">肩こり・五十肩</span>
                            <p className="doc-selection__description">
                                肩まわりの不調が起こる理由と、改善に向けたステップをまとめました。
                            </p>
                        </div>
                        <span className="doc-selection__cta">
                            <ArrowForwardIos className="doc-selection__cta-icon" />
                        </span>
                    </Link>
                    <Link className="doc-selection__card" to="/symptoms/low-back-pain">
                        <span className="doc-selection__icon-wrapper">
                            <HealthAndSafetyOutlined className="doc-selection__icon" />
                        </span>
                        <div className="doc-selection__content">
                            <span className="doc-selection__label">腰痛</span>
                            <p className="doc-selection__description">
                                腰痛の原因やセルフケアの注意点、当院の施術方針をご紹介します。
                            </p>
                        </div>
                        <span className="doc-selection__cta">
                            <ArrowForwardIos className="doc-selection__cta-icon" />
                        </span>
                    </Link>
                    <Link className="doc-selection__card" to="/symptoms/knee-pain">
                        <span className="doc-selection__icon-wrapper">
                            <DirectionsRunOutlined className="doc-selection__icon" />
                        </span>
                        <div className="doc-selection__content">
                            <span className="doc-selection__label">膝の痛み</span>
                            <p className="doc-selection__description">
                                膝痛の主な原因や日常で気をつけたいポイントを分かりやすく解説します。
                            </p>
                        </div>
                        <span className="doc-selection__cta">
                            <ArrowForwardIos className="doc-selection__cta-icon" />
                        </span>
                    </Link>
                </div>
            </div>
        </article>
    </DocPageLayout>
);

export default Symptoms;

